import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { copyright } from 'src/app/core/translations/copyright';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class CopyrightComponent  implements OnInit {

  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';

  currentLanguage: string = '';
  languageTranslations: any = copyright;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
    
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        // console.log(this.activeLanguageTranslations);
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
